import { useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "@api/queryKeys";

import { AgencyCountryResponse } from "./agencyCountry.interface";
import { agencyCountryApis } from "./agencyCountry.service";

export const useAgencyCountryQuery = () => {
  const query = useQuery<AgencyCountryResponse, Error, Record<string, string>>({
    queryKey: [QUERY_KEYS.agencyCountry],
    queryFn: async () => agencyCountryApis.getAgencyCountryData(),
    select: (res) =>
      (res?.data ?? []).reduce((acc, { agencyCode, countryCode }) => {
        acc[agencyCode] = countryCode;
        return acc;
      }, {} as Record<string, string>),
  });

  return query.data;
};
